const {

  REACT_APP_POST_DEALS_CRM_URL: crmDeals,
} = process.env;
async function postData(url = "", data = {}, methodType, cors) {
  // Default options are marked with *

  let headers = new Headers()
        headers.append("x-tenant", "checkemail");
        headers.append("Content-Type", "application/json");
  const response = await fetch(url, {
    mode: cors,
    method: methodType, // *GET, POST, PUT, DELETE, etc.
    headers: headers,

    // credentials: 'same-origin',
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

class OnboardService {
  static async postInitialData(postUrl, body) {
    const data = await postData(postUrl, body, "POST", "cors");

    return data;
  }

  static async postchatbot(chatUrl, body) {
    const data = await postData(chatUrl, body, "POST", "no-cors");
    return data;
  }

  static async postTempData(postUrl, body) {
    const data = await postData(postUrl, body, "POST", "cors");
    return data;
  }


  static async createAccountAndDeal(body, crmID) {
    const data = await postData(crmDeals + crmID, body, "POST", "cors");
    return data;
  }
}
export default OnboardService;
